import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { ImageUpload } from "@/components/site/ImageUpload";
import { Logo } from "@/components/site/Logo";

export default function SettingsPage() {
  const { logo, setLogo } = useSettings();
  const [v, setV] = useState(logo);
  const [busy, setBusy] = useState(false);
  useEffect(() => setV(logo), [logo]);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/settings", { logo: v });
      setLogo(data.logo);
      toast.success("Logo enregistré");
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };

  return (
    <div className="space-y-8 max-w-xl">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Logo du site</h1>
        <p className="text-slate-500 mt-1">Ce logo s'affiche sur toutes les pages et sur la carte verte. Format PNG transparent conseillé.</p>
      </div>
      <div className="rounded-2xl border border-emerald-900/10 bg-white p-6 space-y-5">
        <div className="w-40"><ImageUpload value={v} onChange={setV} testId="settings-logo-upload" label="Téléverser le logo" /></div>
        <div className="flex gap-3">
          <Button onClick={save} disabled={busy || v === logo} className="rounded-full" data-testid="settings-logo-save">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Enregistrer</Button>
          {v !== logo && <Button variant="outline" onClick={() => setV(logo)} data-testid="settings-logo-cancel">Annuler</Button>}
        </div>
      </div>
      <div className="rounded-2xl border border-emerald-900/10 bg-white p-6">
        <div className="text-xs uppercase tracking-[0.14em] text-slate-500 mb-4">Aperçu actuel</div>
        <Logo />
      </div>
    </div>
  );
}
